// extracted by mini-css-extract-plugin
export default {"diffCompareTab":"DiffGroupedView_diffCompareTab__Yy4DT"};